import firebase from "firebase";
import moment from "moment";
export default {
  createTicket(currentUserUid, ticketRemark) {
    let ticketRef = firebase
      .database()
      .ref("tickets")
      .push({});
    let currentTimestamp = moment.utc().format("x");
    return ticketRef.set({
      id: ticketRef.key,
      createdAt: currentTimestamp,
      title: ticketRemark.title,
      from: currentUserUid,
      lastUpdateTime: currentTimestamp,
      status: "open",
      remarks: [
        {
          detail: ticketRemark.detail,
          updatedBy: currentUserUid,
          updatedOn: currentTimestamp
        }
      ]
    });
  },
  getMyTicketsRef(currentUserUid) {
    return firebase
      .database()
      .ref("tickets")
      .orderByChild("from")
      .equalTo(currentUserUid);
  },
  getTicketsForAdmin() {
    return firebase
      .database()
      .ref("tickets")
      .orderByChild("createdAt");
  },
  deleteTicket(ticketId) {
    return firebase
      .database()
      .ref(`tickets/${ticketId}`)
      .remove();
  },
  getTicketDetails(ticketId) {
    return firebase.database().ref(`tickets/${ticketId}`);
  },
  saveTicketRemarks(ticketId, ticketRemarks) {
    return new Promise((resolve, reject) => {
      let currentTimestamp = moment.utc().format("x");
      return firebase
        .database()
        .ref(`tickets/${ticketId}/remarks`)
        .set(ticketRemarks)
        .then(() => {
          return firebase
            .database()
            .ref(`tickets/${ticketId}/lastUpdateTime`)
            .set(currentTimestamp);
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  closeTicket(ticketId) {
    return new Promise((resolve, reject) => {
      let currentTimestamp = moment.utc().format("x");
      return firebase
        .database()
        .ref(`tickets/${ticketId}`)
        .update({
          status: "closed",
          lastUpdateTime: currentTimestamp
        })
        .then(() => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
